import { c as classNames } from './index-8a7d9ef9.js';
import React__default, { useRef, useEffect, useState } from 'react';
import { u as useIsomorphicLayoutEffect, a as useTimeout, P as ProgressRing } from './ProgressRing-28ff74c8.js';
import { C as Card } from './Card-04254226.js';
import { T as Typography } from './Typography-cdf537a9.js';
import { _ as __rest, a as __assign } from './tslib.es6-01f7d394.js';

function CircleCheckIcon(_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20" }, props),
        React__default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.createElement("g", { fill: fillColor, fillRule: "nonzero" },
                React__default.createElement("path", { d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm5.5 7l-6.083 7.167c-.334.416-.917.416-1.25 0l-3.25-3.584c-.167-.166-.167-.416 0-.583l.916-1c.167-.167.334-.167.5-.083L8.5 10.333l5.5-4.75c.167-.166.417-.166.583 0l.834.834c.166.166.166.416.083.583z", transform: "translate(-1157 -374) translate(1157 374)" })))));
}

// https://usehooks-ts.com/react-hook/use-interval
function useInterval(callback, delay) {
    var savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(function () {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(function () { return savedCallback.current(); }, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
}

var styles = {"container":"LoadingPanto_container_2a3099f4","header":"LoadingPanto_header_2a3099f4","itemsContainer":"LoadingPanto_itemsContainer_2a3099f4","items":"LoadingPanto_items_2a3099f4","active":"LoadingPanto_active_2a3099f4","doneIcon":"LoadingPanto_doneIcon_2a3099f4","complete":"LoadingPanto_complete_2a3099f4"};

var LoadingPanto = function (_a) {
    var title = _a.title, items = _a.items, _b = _a.delay, delay = _b === void 0 ? 1500 : _b, onComplete = _a.onComplete;
    var _c = useState(0), state = _c[0], setState = _c[1];
    useInterval(function () {
        setState(state + 1);
    }, state < items.length ? delay : null);
    useTimeout(function () {
        onComplete();
    }, delay * items.length + delay);
    return (React__default.createElement(Card, { className: styles.container },
        React__default.createElement(Typography, { as: "h3", variant: "heading_xl", className: styles.header }, title),
        React__default.createElement(ProgressRing, { radius: 34, stroke: 4, type: "time", animationProps: {
                time: 1500 * items.length,
            }, className: styles.progress }),
        React__default.createElement("div", { className: styles.items }, items.map(function (item, i) { return (React__default.createElement("div", { key: item, className: styles.itemsContainer },
            React__default.createElement(CircleCheckIcon, { className: classNames(styles.doneIcon, state > i && styles.complete) }),
            React__default.createElement(Typography, { as: "p", className: state === i ? styles.active : undefined }, item + (state === i ? "..." : "")))); }))));
};

export { CircleCheckIcon as C, LoadingPanto as L };
